import {
  CHANGE_OF_OWNERSHIP_PROJECTION,
  useGetFacilityProfile,
} from "@src/appV2/FacilityProfile/api/useGetFacilityProfile";
import { useModalState } from "@src/lib/ui-react";
import { Button } from "antd";

import { CopyDnrListDialog, type CopyDnrListOriginWorkplace } from "./CopyDnrListDialog";

interface CopyDnrListButtonProps {
  origin: CopyDnrListOriginWorkplace;
}

/**
 * Admin action for the facility drawer's "Change of Ownership" section. Copies the current
 * (source) workplace's DNR list into a destination workplace, so exclusions carry over across
 * a CHOW migration.
 */
export function CopyDnrListButton(props: CopyDnrListButtonProps) {
  const { origin } = props;
  const modalState = useModalState();

  // Pre-select the destination from the source's change-of-ownership replacement. It must
  // come from the facility-profile API: the drawer this button lives in is built on the
  // legacy `/user/get` payload, whose contract strips `changeOfOwnership`. Sharing the
  // `ChangeOfOwnershipControl`'s projection means we reuse its warm cache entry — usually no
  // extra request.
  const { data: originProfile } = useGetFacilityProfile(origin.id, CHANGE_OF_OWNERSHIP_PROJECTION);
  const defaultDestinationWorkplaceId =
    originProfile?.changeOfOwnership?.replacementFacilityId ?? undefined;

  return (
    <>
      <Button
        type="default"
        onClick={() => {
          modalState.openModal();
        }}
      >
        Copy DNR List
      </Button>
      {modalState.modalIsOpen && (
        <CopyDnrListDialog
          modalState={modalState}
          origin={origin}
          defaultDestinationWorkplaceId={defaultDestinationWorkplaceId}
        />
      )}
    </>
  );
}
